import React, { useState, useEffect } from 'react'
import ApiService from '../../../utils/ApiService';
import {
    Card, Typography, Grid, Box, styled, Chip, MoreVert, Divider, Tooltip, RadioGroup, Radio, FormLabel,
    MenuItem, FormControl, InputLabel, Checkbox, Select, FormGroup, Stack, FilterList, IconButton, PeopleOutline, FormControlLabel,
    WatchLaterOutlined, LocationOnOutlined, ArrowForwardOutlined, Button, Close,
    ListItemAvatar,
} from '../../../utils/AllImportsHelper'
import Menu from '@mui/material/Menu';
import Skeleton from '@mui/material/Skeleton';
import { useDispatch, useSelector } from 'react-redux';
import { closeDrawer } from '../../../features/drawers/drawerSlice';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import InboxIcon from '@mui/icons-material/Inbox';
import DraftsIcon from '@mui/icons-material/Drafts';
import Avatar from '@mui/material/Avatar';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import avatar from "../../../assets/images/Avtaar.png"
import Link from '@mui/material/Link';
import { ContentCut, Delete, NotificationsOff } from '@mui/icons-material';
import { setGenaiWithPostType } from '../../../features/notifications/genaiWithPostTypeSlice';
import NotificationDataDrawer from './NotificationDataDrawer';

const NotificationDrawer = ({parentId, notificationList, notificationAllList, notificationMeta, loading, setNotificationList }) => {
    const [unReadNotificationList, setUnReadNotificationList] = useState([]);
    const [value, setValue] = useState(0);
    const [anchorEl, setAnchorEl] = useState(null);

    const open = Boolean(anchorEl);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const generativeAiStatus = useSelector(state => state.genaiActiveStatus.genaiActiveStatus.genAIactiveStatus);

    const userData = useSelector((state) => state?.user?.userListName);
    /*
    "Post"
    data.attributes.notificationMessage resourceID
    data.attributes.id resourceID 
    imageURl
    */

 

    // const markAllAsRead = () => {
    //     console.debug("notificationData",);
    //     ApiService.put('readNotification',{ userId: userData.userId })
    //         .then(response => {
    //             console.debug("notificationData", response.data.data);
    //         })
    //         .catch(error => {
    //         });
    // };

    const markAllAsRead = () => {
        const notificationIds = notificationList.map(notification => notification.id);
        // const readAt = notificationList.map(notification => notification.readAt);
        // console.log('notification: a1', {notificationIds,notificationList, readAt})
        const payload = {
            userId: userData.userId,
            markAllRead: 1,
        };

        ApiService.put('readNotification', payload)
            .then(response => {
                console.debug("Notification marked as read successfully:", response.data);
                // You might want to update your local notificationList state here
            })
            .catch(error => {
                console.error("Error marking notifications as read:", error);
            });
    };


    // useEffect(() => {
    //     const unRead = notificationList.filter((data) => data.read === 0);
    //     setUnReadNotificationList(unRead);
    // }, [notificationList]);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    function CustomTabPanel(props) {
        const { children, value, index, ...other } = props;

        return (
            <div
                role="tabpanel"
                hidden={value !== index}
                id={`simple-tabpanel-${index}`}
                aria-labelledby={`simple-tab-${index}`}
                {...other}
            >
                {value === index && (
                    <Box sx={{ p: 1 }}>
                        <Box>{children}</Box>
                    </Box>
                )}
            </div>
        );
    }

    CustomTabPanel.propTypes = {
        children: PropTypes.node,
        index: PropTypes.number.isRequired,
        value: PropTypes.number.isRequired,
    };

    function a11yProps(index) {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        };
    }

    const handleDrawerClose = () => {
        dispatch(closeDrawer(parentId));
    };


    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    // const truncateText = (text, wordLimit) => {
    //     const words = text.split(' ');
    //     return words.length > wordLimit ? words.slice(0, wordLimit).join(' ') + '...' : text;
    // };


    return (
        <Box sx={{ width: { sm: '37rem' } }}>
            <Stack sx={{ backgroundColor: "#DBEAFE" }}>
                <Box sx={{ p: '.5rem .1rem' }}>
                    <Grid container direction="row" alignItems="center">
                        <Grid item xs={10}>
                            <Box pl='1rem' display='flex'>
                                <Typography variant="body1" color="text.primary" fontWeight="700" display="block" >Notifications  {notificationMeta?.total > 0 && ` (${notificationMeta.total})`}</Typography>
                            </Box>
                            {notificationMeta?.data?.unreadCount ?

                                <Box pl='1rem' display='flex'>
                                    <Typography variant="body2" color="text.primary" display="block" >You have {notificationMeta?.data?.unreadCount} unread messages</Typography>
                                </Box>
                                : ""
                            }
                        </Grid>
                        <Grid item xs={2} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <IconButton aria-label="Close Drawer" component="label" onClick={handleDrawerClose} color='black'>
                                <Close sx={{ color: 'black' }} />
                            </IconButton>
                        </Grid>
                    </Grid>
                </Box>
            </Stack>
            <Box sx={{ height: 'calc(100vh - 64px)', overflow: 'auto', padding: '0rem 1rem 1rem 1rem' }}>
                <Box sx={{ width: '100%' }}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                            {/* <Tab label="Recent" {...a11yProps(0)} /> */}
                            <Tab label="All" {...a11yProps(0)} />
                        </Tabs>
                    </Box>
                    <CustomTabPanel value={value} index={0}>
                        {/* {notificationList.length !== 0 ?  */}
                        {loading ? (
                            <List>
                                {[...Array(5)].map((_, index) => (
                                    <ListItem key={index} disablePadding>
                                        <ListItemButton>
                                            <ListItemAvatar>
                                                <Skeleton variant="circular" width={50} height={50} />
                                            </ListItemAvatar>
                                            <ListItemText
                                                primary={<Skeleton variant="text" width="80%" />}
                                                secondary={<Skeleton variant="text" width="60%" />}
                                            />
                                        </ListItemButton>
                                    </ListItem>
                                ))}
                            </List>):
                            notificationList.length !== 0 ? (<Box>
                                <Box>
                                    {notificationMeta?.total ?
                                        <Link onClick={markAllAsRead} sx={{ cursor: 'pointer' }}>Mark all as read</Link>
                                        : ""}
                                </Box>
                                <Box>
                                    <NotificationDataDrawer
                                        loading={loading}
                                        notificationList={notificationList}
                                        handleClick={handleClick}
                                        anchorEl={anchorEl}
                                        open={open}
                                        handleClose={handleClose}
                                        generativeAiStatus={generativeAiStatus}
                                        dispatch={dispatch}
                                        closeDrawer={closeDrawer}
                                        setNotificationList={setNotificationList}
                                        setGenaiWithPostType={setGenaiWithPostType} />
                                </Box>
                            </Box>
                        ) : (
                        <Box sx={{ p: 2, display: 'flex', alignItems: 'center' }}>There is no notification data</Box>
                        )
                        }
                    </CustomTabPanel>
                    <CustomTabPanel value={value} index={1}>
                        {notificationAllList.length !== 0 ? (
                            <Box>
                                <Box>
                                    <Link onClick={markAllAsRead} sx={{ cursor: 'pointer' }}
                                    >Mark all as read</Link>
                                </Box>
                                <Box>
                                    <NotificationDataDrawer
                                        loading={loading}
                                        handleClick={handleClick}
                                        notificationList={notificationAllList}
                                        anchorEl={anchorEl}
                                        open={open}
                                        handleClose={handleClose}
                                        generativeAiStatus={generativeAiStatus}
                                        dispatch={dispatch}
                                        closeDrawer={closeDrawer}
                                        setGenaiWithPostType={setGenaiWithPostType} />
                                </Box>
                            </Box>
                        ) : (
                            <Box sx={{ p: 2, display: 'flex', alignItems: 'center' }}>There is no notification data</Box>
                        )}
                    </CustomTabPanel>
                </Box>
            </Box>
        </Box>
    );
}

export default NotificationDrawer;
